import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import { productionOrderStates as states } from '../../../Config/productionOrderStates'
import { useTranslation } from 'react-i18next';

export default function FinishOrderDialog(props) {

    const classes = useStyles();
    const {t} = useTranslation();

    function PaperComponent(props) {
        return (
            <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
                <Paper {...props} />
            </Draggable>
        );
    }

    const finishOrder = () => {    
        props.action(states.DONE)
        props.closeDialog()
    }

    let totalPallets = 0;
    let progress = 0;

    if(props.productionOrder){
        if(props.productionOrder.bomOut.length > 0){
            totalPallets = Math.ceil(props.productionOrder.bomOut[0].quantityToProduce / props.productionOrder.bomOut[0].quantityOnCarrier)
        }
    
        if(props.producedBOMOut){
            progress =  Math.ceil(props.producedBOMOut.quantityProduced / props.productionOrder.bomOut[0].quantityOnCarrier) +1
        }    
    } 

    return (

        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >   <div className={classes.headerIcon}> <img className={classes.menuIcon} alt="jobComplete" src={process.env.PUBLIC_URL + '/img/jobComplete.svg'}></img>
            </div>
            <DialogTitle className={classes.dialogTitle} id="draggable-dialog-title">
                {props.dialogTitle}
            </DialogTitle>
            <DialogContentText className={classes.dialogContext}>
                {props.dialogContext}
            </DialogContentText>
            <div className={classes.dialogTable}>
                <div className={classes.row}>
                    <div className={classes.nameCell}>
                        {t("Line")}
                    </div>
                    <div className={classes.valueCell}>
                        {props.productionOrder.machinePlannedCode}
                    </div>
                </div>
                <div className={classes.row}>
                    <div className={classes.nameCell}>
                        {t("Pieces produced")}
                    </div>
                    <div className={classes.valueCell}>
                        {props.productionOrder.bomOut[0].quantityToProduce + "/" + props.productionOrder.bomOut[0].quantityToProduce}
                    </div>
                </div>
                <div className={classes.row}>
                    <div className={classes.nameCell}>
                        {t("Palets produced")}
                    </div>
                    <div className={classes.valueCell}>
                        {totalPallets + "/" + totalPallets}
                    </div>
                </div> </div>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.completeButton} autoFocus onClick={() => finishOrder()} >
                        <img className={classes.done} alt="done" src={process.env.PUBLIC_URL + '/img/done_white.svg'}></img>{t("DONE")}
                 </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "520px !important",
        height: "420px !important",
        margin: "auto"
    },
    buttons: {
        width: "520px",
        textAlign: "center"
    },
    completeButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: "#5CC958",
        '&:hover': {
            backgroundColor: "#5CC958",
        },
        margin: "3px",
        width: "150px",
        marginBottom: "20px"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "0px",
        cursor: 'move'
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center"
    },
    headerIcon: {
        height: "80px",
        width: "100%",
        marginTop: "20px",
        textAlign: "center",
        padding: "20px",
        boxSizing: "border-box"
    },
    row: {
        width: "100%",
        height: "25px"
    },
    valueCell: {
        width: "40%",
        textAlign: "right",
        float: "left",
        color: "#020100",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'regular',
    },
    nameCell: {
        width: "60%",
        textAlign: "left",
        float: "left",
        color: "#020100",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
    },
    dialogTable: {
        height: "80px",
        width: "100%",
        paddingLeft: "60px",
        paddingRight: "60px",
        boxSizing: "border-box"
    },
    done: {
        height: "20px",
        width: "20px",
        marginRight: "10px",
        color: "white"
    },
}));
